module.exports = __webpack_public_path__ + "static/media/logo_red.af199ad3.png";